/**
 * Format Thai phone number
 *   10 digits (mobile)  → XXX-XXX-XXXX
 *   9 digits, starts "02" (Bangkok landline) → XX-XXX-XXXX
 *   9 digits, others   (regional landline)  → XXX-XXX-XXX
 *   partial input      → best-effort grouping while typing
 */
export function formatThaiPhone(value) {
  const digits = (value || "").replace(/\D/g, "").slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  if (digits.length === 9) {
    if (digits.startsWith("02"))
      return `${digits.slice(0, 2)}-${digits.slice(2, 5)}-${digits.slice(5)}`; // 02-XXX-XXXX
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`; // 0XX-XXX-XXX
  }
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`; // 10 digits or partial 7-8
}
